import { increment, onSnapshot, orderBy, query, serverTimestamp, setDoc } from 'firebase/firestore'
import { tagRef, tagsRef } from './paths'

/** Tags are lowercased and trimmed so near-duplicates don't accumulate. */
export function normaliseTag(raw: string): string {
  return raw.trim().toLowerCase().replace(/\s+/g, '-')
}

export function parseTags(input: string): string[] {
  const seen = new Set<string>()
  for (const part of input.split(',')) {
    const tag = normaliseTag(part)
    if (tag) seen.add(tag)
  }
  return [...seen]
}

/** Bumps the usage counters that feed tag autocomplete. Never blocks a save. */
export async function recordTagUse(uid: string, tags: string[]): Promise<void> {
  await Promise.all(
    tags.map((tag) =>
      setDoc(
        tagRef(uid, tag),
        { label: tag, useCount: increment(1), lastUsedAt: serverTimestamp() },
        { merge: true },
      ).catch(() => undefined),
    ),
  )
}

export function subscribeTags(
  uid: string,
  onChange: (tags: string[]) => void,
  onError?: (error: Error) => void,
): () => void {
  return onSnapshot(
    query(tagsRef(uid), orderBy('useCount', 'desc')),
    (snapshot) => onChange(snapshot.docs.map((doc) => doc.id)),
    (error) => onError?.(error),
  )
}
